export const educationData = [
  {
    title: "University of Moratuwa, Sri Lanka",
    date: "September 2017 - April 2022",
    subTitle: "B.Sc. Engineering (Electronics and Telecommunications)",
    details: "Semester 6 Undergraduate"
  },
  {
    title: "Maliyadeva College, Sri Lanka",
    date: "June 2014 - August 2016",
    subTitle: "G.C.E. Advance Level ",
    details: "Island rank 153 and Zscore of 2.3117"
  }
];
